import actionTypes from "../actionTypes";
import * as zpCPrioritaUtils from "../../utils/ciselniky/zpCPrioritaUtils";

export const changePriorita = (priorita) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_PRIORITA,
      data: priorita,
    });
  };
};
const getZP_C_PRIORITA_Request = () => ({
  type: actionTypes.GET_ZP_C_PRIORITA_REQUEST,
});
const getZP_C_PRIORITA_Success = (res) => ({
  type: actionTypes.GET_ZP_C_PRIORITA_SUCCESS,
  res,
});
const getZP_C_PRIORITA_Failure = (error) => ({
  type: actionTypes.GET_ZP_C_PRIORITA_FAILURE,
  error,
});
export const getZP_C_PRIORITA = () => {
  return async (dispatch) => {
    try {
      dispatch(getZP_C_PRIORITA_Request());
      let res = await zpCPrioritaUtils.getZP_C_PRIORITA();
      dispatch(getZP_C_PRIORITA_Success(res));
    } catch (error) {
      dispatch(getZP_C_PRIORITA_Failure(error));
    }
  };
};
